import React from 'react';

function PipelineTransitionModal({
  dialog,
  form,
  onClose,
  onFormChange,
  onSubmit,
  getConfig
}) {
  if (!dialog) return null;

  const config = getConfig(dialog);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>{config.title}</h3>
        <p className="modal-text">{config.message}</p>
        <div className="form-group">
          <label>{config.reasonLabel}</label>
          <input
            type="text"
            value={form.reason}
            onChange={(e) => onFormChange((prev) => ({ ...prev, reason: e.target.value }))}
            placeholder={config.reasonPlaceholder}
          />
        </div>
        <div className="form-group">
          <label>{config.noteLabel}</label>
          <textarea
            value={form.note}
            onChange={(e) => onFormChange((prev) => ({ ...prev, note: e.target.value }))}
            placeholder={config.notePlaceholder}
          />
        </div>
        {dialog.action === 'block' && (
          <div className="form-group">
            <label>Blocked reason *</label>
            <input
              type="text"
              value={form.blocked_reason}
              onChange={(e) => onFormChange((prev) => ({ ...prev, blocked_reason: e.target.value }))}
              placeholder="Why is this blocked?"
            />
          </div>
        )}
        <div className="modal-actions">
          <button type="button" onClick={onClose}>Cancel</button>
          <button type="button" className="btn-edit" onClick={onSubmit}>{config.confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

export default PipelineTransitionModal;
